




























import { Component, Vue } from "vue-property-decorator";
import { TweenMax } from "gsap";
@Component
export default class Makimono extends Vue {
  $refs!: {
    makimono: HTMLElement;
  };

  observer: MutationObserver | null = null;
  makimonoWidth = 0;
  makimonoHeight = 0;
  showDecoration = false;

  get makimonoBorderImageWidth() {
    return `border-image-width: 0 ${(107 * this.makimonoHeight) / 860}px;`;
  }
  mounted() {
    this.$nextTick(() => {
      // 巻物のサイズ変更時の値を取得
      const makimono = this.$refs.makimono;
      this.makimonoWidth = makimono.getBoundingClientRect().width;
      this.makimonoHeight = makimono.getBoundingClientRect().height;
      this.observer = new MutationObserver(() => {
        this.makimonoWidth = makimono.getBoundingClientRect().width;
        this.makimonoHeight = makimono.getBoundingClientRect().height;
      });
      this.observer.observe(makimono, {
        attributes: true,
        attributeFilter: ["style"]
      });
      // ウィンドウサイズ変更時の値を取得
      window.addEventListener("resize", this.resize);
      TweenMax.fromTo(
        this.$refs.makimono,
        { width: 0 },
        {
          width: "90%",
          duration: 1,
          onComplete: () => {
            this.showDecoration = true;
            this.$emit("endAnimation");
          }
        }
      );
    });
  }

  beforeUnmount() {
    this.observer = null;
    window.removeEventListener("resize", this.resize);
  }

  resize() {
    const makimono = this.$refs.makimono;
    this.makimonoWidth = makimono.getBoundingClientRect().width;
    this.makimonoHeight = makimono.getBoundingClientRect().height;
  }
}
